import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { User } from 'src/app/models/auth/user';
import { DeviceDetailsComponent } from 'src/app/device-management/device-details/device-details.component';
import { ConfirmationPopupComponent } from 'src/app/shared/confirmation-popup/confirmation-popup.component';
import { ConfirmationResult } from 'src/app/models/common/confirmationResult';
import { MatDialog } from '@angular/material/dialog';
import { NavigationConfirmationPopupComponent } from 'src/app/shared/navigation-confirmation-popup/navigation-confirmation-popup.component';
import { DataPersistenceService } from './data-persistence.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({ providedIn: "root" })
export class DataPersistenceGuard implements CanDeactivate<DeviceDetailsComponent> {
    constructor(public dialog: MatDialog, private dataPersistenceService: DataPersistenceService, private translocoService: TranslocoService){         
        this.isFormPristine$.next(true);   
        this.formDirtyCollection = [];    
    }
    private flag: boolean = false;
    private isFormDirty: boolean = false;
    private formDirtyCollection: any = [];
    isFormPristine$: Subject<boolean> = new Subject();
    deactivateReturnFlag$: Subject<boolean> = new Subject();
    canDeactivate(component: DeviceDetailsComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot | undefined): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {           
        if(this.dataPersistenceService.getTabInserted().length == 1){
            if(this.findTrueFlagInCollection()){
                const confirmDialogRef = this.dialog.open(ConfirmationPopupComponent, {
                    disableClose: true,
                    data: {
                      message: this.translocoService.translateObject("ConfirmationPopup"),
                      icon:"../../../assets/icons/status-icon-confirmation.svg"
                    }
                  });
              
                      confirmDialogRef.afterClosed().subscribe((result: ConfirmationResult) => {
                          if (result === ConfirmationResult.confirm) {                            
                            this.dataPersistenceService.updateConfirmationPopupStatus({status:ConfirmationResult.confirm, context: this.dataPersistenceService.getTabInserted()});
                            return this.deactivateReturnFlag$.asObservable();                            
                          }
                          else if (result === ConfirmationResult.reject) {                            
                            this.dataPersistenceService.updateConfirmationPopupStatus({status:ConfirmationResult.reject, context: this.dataPersistenceService.getTabInserted()});                            
                            return this.deactivateReturnFlag$.asObservable();
                          }
                          else if(result === ConfirmationResult.cancel){
                            this.deactivateReturnFlag$.next(false);
                            return this.deactivateReturnFlag$.asObservable();                            
                            }
                            else{
                                this.deactivateReturnFlag$.next(false);
                                return this.deactivateReturnFlag$.asObservable();
                            }
                      });
                      return this.deactivateReturnFlag$.asObservable();                      
            }
            else{
                return true;
            }            
            
        }
        else{
            if(this.findTrueFlagInCollection()){
                const confirmDialogRef = this.dialog.open(NavigationConfirmationPopupComponent, {
                    disableClose: true,
                    data: {
                      message: "Save your changes?",
                      icon:"../../../assets/icons/icon-rejected.svg"
                    }
                  });
              
                  confirmDialogRef.afterClosed().subscribe((result: ConfirmationResult) => {
                    if (result === ConfirmationResult.confirm) {
                      console.log('confirm');
                      return false;
                    }
                    else if(result === ConfirmationResult.reject) {
                        return false;
                    }
                    else{
                        return false;
                    }
                  });
                  return false;
            }
            else{
                return true;
            } 
        }                       
    }
    isNavigationAllowed(): boolean{
        return true;
    }
    formStatusUpdate(status){
        this.isFormPristine$.next(status)
    }
    formDirtyStatusUpdate(status, statusObj){
        this.isFormDirty = status;
        if(this.formDirtyCollection.findIndex(x =>x.context === statusObj.context) == -1){
            this.formDirtyCollection.push(statusObj)
        }
        else{
            if(!statusObj.isFormDirty){
                this.formDirtyCollection.splice(this.formDirtyCollection.findIndex(x =>x.context === statusObj.context),1);
            }            
        }
    }
    findTrueFlagInCollection(){
        let flag: boolean = false;       
        this.formDirtyCollection.forEach(element=>{
            if(element.isFormDirty){
                flag = true;                
            }            
        });    
        return flag;    
    }
}